import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { Button, Text, Spacer } from '@zillow/constellation';

import ModalConstants from 'app/shared/constants/ModalConstants';
import ModalActions from 'app/shared/actions/ModalActions';
import SavedSpecialOfferCard from './SavedSpecialOfferCard';

const propTypes = {
    isInputFormDisabled: PropTypes.bool,
    specialOffers: PropTypes.array.isRequired,
    updateFormData: PropTypes.func.isRequired,
};

const defaultProps = {
    isInputFormDisabled: false,
};

const SpecialOffers = ({
    isInputFormDisabled,
    specialOffers,
    updateFormData,
}) => {
    const dispatch = useDispatch();

    const addSpecialOffer = () => {
        dispatch(ModalActions.showModal({
            modalType: ModalConstants.ADD_SPECIAL_OFFER_MODAL,
            header: 'Add special offer',
            updateFormData,
            specialOffers,
            isFluid: true,
        }));
    };

    return (
        <div className="SpecialOffers">
            <Spacer marginBottom="sm">
                <Text fontType="h4">Special Offers</Text>
            </Spacer>
            {specialOffers.length > 0 && specialOffers.map(
                (offer, i) => (
                    <SavedSpecialOfferCard
                        specialOffers={specialOffers}
                        offerToDisplay={offer}
                        index={i}
                        updateFormData={updateFormData}
                        key={i}
                    />
                )
            )}
            {specialOffers.length < 5 && (
                <Spacer marginY="sm">
                    <Button
                        buttonType="primary"
                        onClick={addSpecialOffer}
                        disabled={isInputFormDisabled}
                    >
                        + Add Offer
                    </Button>
                </Spacer>
            )}
        </div>
    );
};


SpecialOffers.propTypes = propTypes;
SpecialOffers.defaultProps = defaultProps;

export default SpecialOffers;
